import {FilterValues, FilterOptions} from '../interfaces/FilterOptions';
import filterOptions from '../constants/FilterOptions';
import formatLabel from 'utils/formatLabel';
import {Site} from 'hooks/useSiteInfo/interfaces/Site';

// Get the valid values for the filter options
const getValidValues = (data: Site[], type: keyof Site): FilterValues => {
  return Array.from(new Set(data.map(item => item[type])))
    .filter(value => value)
    .reduce((acc, value) => {
      acc[value as string] = {
        label: formatLabel(value as string),
      };
      return acc;
    }, {} as FilterValues);
};

// Build the new filter options based on the inventory data
function getFilterOptions(inventoryData: Site[]): FilterOptions {
  const updatedFilterOptions = Object.keys(filterOptions).reduce((options, type) => {
    const key = type as keyof Site;
    const values = getValidValues(inventoryData, key);

    options[type] = {
      ...filterOptions[type],
      values: values,
    };
    return options;
  }, {} as FilterOptions);
  return updatedFilterOptions;
}

export default getFilterOptions;
